import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="yet-another-date-picker"
export default class extends Controller {
  currentDate;

  connect() {
    this.currentDate = ""
    const f = this.formatDate.bind(this)

    this.element.addEventListener("change", f)
    this.element.addEventListener("keyup", f)
  }

  formatDate() {
    const newValue = this.element.value
    
    if (newValue.slice(-2) === "//") {
      this.element.value = newValue.slice(0, -1)
    } else if (this.currentDate.split("/").length !== newValue.split("/").length) {
      this.element.value = newValue
    } else if (newValue.length === 1 && parseInt(newValue) > 1) {
      this.element.value = newValue + "/"
    } else if (newValue.length === 2 && newValue.indexOf("/") === -1) {
      this.element.value = newValue + "/"
    } else if (newValue.split("/").length === 2) {
      const spl = newValue.split("/")

      if (spl[1] !== "" && ((parseInt(spl[1]) > 3 && parseInt(spl[1]) < 10) || spl[1].length === 2)) {
        this.element.value = newValue + "/"
      }
    } 

    this.currentDate = this.element.value
  }
}
